export default __webpack_public_path__ + "static/media/IMPORT_DATA_SHOP.2cb691a7.xlsx";